export default {
  data() {
    return {
      tabs: [
        {
          to: "/profile",
          title: "My Profile",
        },
        {
          to: "/profile/quicklinks",
          title: "My Quick Links",
        },
        {
          to: "/profile/notifications",
          title: "Notification Preferences",
        },
      ],
    };
  },
  computed: {
      activeTab() {
          return this.tabs.findIndex(item => item.to == this.$route.path)
      }
  },
};
